import Cookies from 'js-cookie'

const TokenKey = 'admin_token_demo'
const userInfoKey = 'admin_user_info'
const loginType = 'admin_login_type'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getUserInfo() {
  return JSON.parse(sessionStorage.getItem(userInfoKey))
}
export function setUserInfo(info) {
  return sessionStorage.setItem(userInfoKey,JSON.stringify(info))
}

export function removeUserInfo() {
  return sessionStorage.removeItem(userInfoKey)
}


export function setloginType(type) {
  return sessionStorage.setItem(loginType,JSON.stringify(type))
}
export function getloginType() {
  return JSON.parse(sessionStorage.getItem(loginType))
}